import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { defaultOrderStatus, OrderStatus } from "../../models/responses/orderStatus";

export interface OrderStatusState {
    orderStatusListForMenu: OrderStatus[];
    orderStatus: OrderStatus;
    setOrderStatusList: OrderStatus[];
    isWaitingOrderStatusGetResponse?: boolean;
    isWaitingOrderStatusPostResponse?: boolean;
    isWaitingOrderStatusListGetResponse?: boolean;
    isWaitingOrderStatusPutResponse?: boolean;
}

const initialState: OrderStatusState = {
    orderStatusListForMenu: [],
    setOrderStatusList: [],
    orderStatus: { ...defaultOrderStatus },
    isWaitingOrderStatusGetResponse: false,
    isWaitingOrderStatusPostResponse: false,
    isWaitingOrderStatusListGetResponse: false,
    isWaitingOrderStatusPutResponse: false,
};

const orderStatusSlice = createSlice({
    name: 'orderStatus',
    initialState,
    reducers: {
        setOrderStatusListForMenu: (state, action: PayloadAction<{
            orderStatusListForMenu: OrderStatus[];
        }>) => {
            state.orderStatusListForMenu = action.payload.orderStatusListForMenu || initialState;
            return state;
        },  
        setOrderStatusList: (state, action: PayloadAction<{
            setOrderStatusList: OrderStatus[];
        }>) => {
            state.setOrderStatusList = action.payload.setOrderStatusList || initialState;
            return state;
        },
        setOrderStatus: (state, action: PayloadAction<{
            orderStatus: OrderStatus;            
        }>) => {
            state.orderStatus = action.payload.orderStatus || initialState;
            return state;
        },
        setIsWaitingOrderStatusGetResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingOrderStatusGetResponse = action.payload;
            return state;
        },
        setIsWaitingOrderStatusPostResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingOrderStatusPostResponse = action.payload;
            return state;
        },
        setIsWaitingOrderStatusListGetResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingOrderStatusListGetResponse = action.payload;
            return state;
        },
        setIsWaitingOrderStatusPutResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingOrderStatusPutResponse = action.payload;
            return state;
        }
    },
});

export const {
    setOrderStatusListForMenu,
    setOrderStatus,
    setOrderStatusList,
    setIsWaitingOrderStatusGetResponse,
    setIsWaitingOrderStatusPostResponse,
    setIsWaitingOrderStatusListGetResponse,
    setIsWaitingOrderStatusPutResponse
} = orderStatusSlice.actions;

export default orderStatusSlice.reducer;